<template>
  <DashboardPanel
    panel-id="v-pills-assessments"
    aria-labelledby="v-pills-assessments-tab"
    title="Assessments"
    :subtitle="assessments.length ? `${assessments.length} test${assessments.length === 1 ? '' : 's'} assigned to you` : 'Skill tests shared by employers'"
  >
    <div v-if="assessments.length" class="hc-activity-list">
      <article
        v-for="assessment in assessments"
        :key="assessment.tracker_id"
        class="hc-activity-card"
        :class="{ 'hc-activity-card--expired': assessment.test_taken || checkExpired(assessment.last_date) }"
      >
        <h3
          class="hc-activity-card__title hc-activity-card__title--link"
          @click="showDetails(assessment.tracker_id)"
        >{{ assessment.test_name }}</h3>

        <template v-if="!assessment.test_taken">
          <p class="hc-activity-card__meta"><strong>Sent by</strong> {{ assessment.client_name }}</p>
          <div class="hc-activity-card__footer">
            <p class="hc-activity-card__detail"><strong>Last date:</strong> {{ getDateWithTime(assessment.last_date) }}</p>
            <a
              v-if="!checkExpired(assessment.last_date)"
              class="hc-status-pill hc-status-pill--proceed"
              :href="assessment.join_link"
              target="_blank"
              rel="noopener"
            >Proceed</a>
            <span v-else class="hc-status-pill hc-status-pill--expired">Expired</span>
          </div>
        </template>

        <template v-else>
          <div v-for="(company, i) in assessment.company" :key="i" class="hc-activity-card__meta">
            <strong>Sent by</strong> {{ company }}
          </div>
          <div class="hc-activity-card__footer">
            <div>
              <p class="hc-activity-card__detail mb-1"><strong>Score:</strong> {{ assessment.score }} / {{ assessment.total_marks }}</p>
              <p class="hc-activity-card__detail"><strong>Attempted:</strong> {{ getDateWithTime(assessment.test_taken_on) }}</p>
            </div>
            <span class="hc-status-pill hc-status-pill--completed">Completed</span>
          </div>
        </template>
      </article>
    </div>

    <div v-else class="hc-panel__empty">
      <i class="mdi mdi-clipboard-text-outline hc-panel__empty-icon" aria-hidden="true"></i>
      <h3>No assessments yet</h3>
      <p>When an employer shares a skill test with you, it will show up here with a link to begin.</p>
    </div>

    <b-modal id="assessment-modal" hide-footer :title="current_assess.test_name" size="lg">
          <div class="container">
            <div class="col">
              <p><strong>Total duration: </strong>{{ current_assess.total_duration}}</p>
              <p><strong>Total marks: </strong> {{ current_assess.total_marks }}</p>
              <div v-if="!current_assess.test_taken">
                <p><strong>Last date: </strong> {{getDateWithTime(current_assess.last_date)}}</p>
                <p v-if="!checkExpired(current_assess.last_date)"><strong><a :href="current_assess.join_link" target="_blank">Click here to go to test</a></strong></p>
              </div>
            </div>
            <section>
                  <table class="table table-bordered w-auto mt-3 mx-auto">
                      <thead>
                          <tr>
                              <th>Section name</th>
                              <th>No. of questions</th>
                          </tr>
                      </thead>
                        <tbody v-if="current_assess.section_question_details">
                          <tr v-for="(section, index) in JSON.parse(current_assess.section_question_details)" :key="index">
                              <td>{{section.section_name}}</td>
                              <td>{{section.total_questions}}</td>
                          </tr>
                      </tbody>
                  </table>
              </section>
          </div>
        </b-modal>
  </DashboardPanel>
</template>

<script>
import Actions from '../libraries/apiActions.js';
import DashboardPanel from './Dashboard/DashboardPanel.vue';

import '../assets/hire.css';
export default {
  name: 'Assessments',
  components: { DashboardPanel },
  data(){
    return{
      action: new Actions(),
      assessments: [],
      current_assess: {
        test_name: '',
        section_question_details: null,
        test_date_from: '',
        test_date_to: '',
        join_link: '',
        last_date: '',
        total_duration: '',
        total_marks: '',
        total_no_of_questions: ''
      }

      // length: 0,
      // page:1,
      // offset: 0,
      // limit: 25,
      // total: 0,
    }
  },
  beforeMount(){
    this.loadAssessments();
  },
  methods:{
    loadAssessments() {
      let token = this.$cookies.get("hire-seeker").token;
      this.action.getAssessments(token).then((res) => {
          if(res.success) {
              this.assessments = res.assessments;
              // this.limit = res.meta.limit;
              // this.offset = res.meta.offset;
              // this.total = res.meta.total;
              // this.length = Math.ceil(res.meta.total/res.meta.limit);
          }
      }).catch((err) => {
          console.log(err)
      });
    },
    showDetails(tracker_id){
      let token = this.$cookies.get("hire-seeker").token;
      this.action.getTestDetails(tracker_id, token).then((res) => {
          if(res.success) {
              this.current_assess = res.assessment;
              this.$bvModal.show('assessment-modal');
          }
      }).catch((err) => {
          console.log(err)
      });
    },
    checkExpired(ts){
      let current_time = new Date().getTime()/1000;
      if(current_time > ts) return true;
      else return false;
    },
    getTime(ts) {
        var timestamp = ts * 1000;
        var date = new Date(timestamp);
        return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    },
    getDateWithTime(ts) {
        var months = ['Jan', 'Feb' , 'Mar' , 'Apr' , 'May' , 'June' , 'July' , 'Aug' , 'Sep' , 'Oct' , 'Nov' , 'Dec' ];

        var timestamp = ts * 1000;
        var date = new Date(timestamp);

        return date.getDate()+
            " "+months[date.getMonth()]+
            " "+date.getFullYear() +
            ", "+ date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
              
      },
    pad(n){
      if(n < 10) return '0'+n; else return n;
    },
    checkDate(ts) {
          let exp_ts = ts + 1800;
          let current_time = new Date().getTime()/1000
          if(current_time < ts) return 'upcoming';
          else if(ts < current_time && current_time< exp_ts) return 'active';
          else if(current_time > exp_ts) return 'expired';
      },
    getHelpText(ts) {
        let exp_ts = ts + 1800;
        let current_time = new Date().getTime()/1000
        if(current_time < ts) return 'Interview not started yet, retry at the scheduled time';
        else if(current_time > exp_ts) return 'Interview link has been expired';
    },
  }
}
</script>
